<td-wb-modal-header>
  <td-wb-modal-header-title modalTitle="tdWb.lti.assumptions.ASSUMPTION_TITLE" />
  <td-wb-modal-header-buttons>
    <td-wb-modal-close-button />
  </td-wb-modal-header-buttons>
</td-wb-modal-header>
<td-wb-modal-panel [top]="true"
                   [bottom]="true">
  <div class="td-wb-assumptions">
    <p class="td-wb-assumptions__description">
      <span translate="tdWb.lti.assumptions.DESCRIPTION"></span>
      <a class="td-wb-link"
         tdWbOpenWindow="link_lti_methodology_whitepaper">
        <span translate="tdWb.lti.assumptions.METHODOLOGY"></span>
      </a>
      <span translate="tdWb.lti.assumptions.DESCRIPTION_LEARN_MORE"></span>
    </p>
    <h3 id="td-wb-aria-assumptions-risk-return-header"
        class="td-wb-assumptions__header"
        translate="tdWb.lti.assumptions.RISK_RETURN"></h3>
    <td-wb-divider class="td-wb-assumptions__divider td-wb-assumptions__divider--top" />
    <div class="td-wb-assumptions__profile">
      <div class="td-wb-assumptions__sub-header-container">
        <span class="td-wb-assumptions__sub-header"
              translate="tdWb.lti.assumptions.INVESTOR_PROFILE"></span>
        <td-wb-lti-assumptions-tooltip sectionId="INVESTOR_PROFILE"
                                       position="center-right" />
      </div>
      @if (hasInvestorProfileModel()) {
        <span class="td-wb-assumptions__value"
              [translate]="'tdWb.lti.assumptions.'+ profileModelType"></span>
      }
      <a class="td-wb-link"
         role="button"
         tabindex="0"
         tdWbHref="page.lti.investor-profile.select"
         [tdWbHrefParams]="{ goalId: goalId }">
        <span translate="tdWb.lti.assumptions.CHANGE_PROFILE"></span>
        <td-wb-icon iconId="caret-right--small"
                    [inline]="true" />
      </a>
      <td-wb-divider class="td-wb-assumptions__profile-divider--bottom" />
    </div>
    <div class="td-wb-assumptions__return">
      <td-wb-inline-icon-wrapper>
        <span class="td-wb-assumptions__sub-header"
              translate="tdWb.lti.assumptions.ANNUAL_RETURNS"></span>
        <td-wb-lti-assumptions-tooltip sectionId="ANNUAL_RETURNS"
                                       position="center-bottom" />
      </td-wb-inline-icon-wrapper>
      @if (hasInvestorProfileModel()) {
        <span class="td-wb-assumptions__value"
              [innerText]="annualReturns | tdWbPercent: { format: 'n1' }">
        </span>
      }
    </div>
    <div class="td-wb-assumptions__deviation">
      <td-wb-inline-icon-wrapper>
        <span class="td-wb-assumptions__sub-header"
              translate="tdWb.lti.assumptions.STANDARD_DEVIATION"></span>
        <td-wb-lti-assumptions-tooltip sectionId="STANDARD_DEVIATION"
                                       position="center-left" />
      </td-wb-inline-icon-wrapper>
      @if (hasInvestorProfileModel()) {
        <span class="td-wb-assumptions__value"
              [innerText]="standardDeviation |  tdWbPercent: { format: 'n1' }">
        </span>
      }
    </div>
    <td-wb-divider class="td-wb-assumptions__divider td-wb-assumptions__divider--bottom" />
    <ng-container *ngTemplateOutlet="isRetirementGoal() ? retirementTemplate : undefined" />
  </div>
</td-wb-modal-panel>

<ng-template #retirementTemplate>
  <h3 id="td-wb-aria-modify-assumptions-header"
      class="td-wb-assumptions__header"
      translate="tdWb.lti.assumptions.MODIFY_ASSUMPTIONS"></h3>
  <td-wb-form class="td-wb-assumptions__form"
              (submitAction)="onAssumptionSaveClick()">
    <td-wb-form-row class="td-wb-assumptions__form-row">
      <div> <!--the following is for Canadian Pension Plan or Quebec Pension Plan-->
        <td-wb-inline-icon-wrapper class="td-wb-assumptions__form-row-title">
          <span translate="tdWb.lti.assumptions.PENSION_PLAN"></span>
          <td-wb-lti-assumptions-tooltip sectionId="PENSION_PLAN"
                                         position="center-bottom" />
        </td-wb-inline-icon-wrapper>
        <div class="td-wb-assumptions__spaced-row">
          <div class="td-wb-assumptions__spaced-column">
            <div id="td-wb-aria-pension-plan-label"
                 translate="tdWb.lti.assumptions.INCLUDE_CPP_QPP"></div>
            <td-wb-radio-group id="td-wb-lti-pension-plan"
                               aria-labelledby="td-wb-aria-pension-plan-label"
                               [(ngModel)]="includeCPPQPP"
                               (change)="onIncludeCPPQPPChange()">
              <td-wb-radio name="noPensionPlan"
                           value="No">
                <span translate="tdWb.lti.assumptions.NO_OPTION"></span>
              </td-wb-radio>
              <td-wb-radio name="CPPPensionPlan"
                           value="CPP">
                <span translate="tdWb.lti.assumptions.CPP_OPTION"></span>
              </td-wb-radio>
              <td-wb-radio name="QPPPensionPlan"
                           value="QPP">
                <span translate="tdWb.lti.assumptions.QPP_OPTION"></span>
              </td-wb-radio>
            </td-wb-radio-group>
          </div>
          <div class="td-wb-assumptions__spaced-column">
            <span translate="tdWb.lti.assumptions.AVERAGE_CPP_AMOUNT"></span>
            <td-wb-input-group class="td-wb-assumptions__full-width">
              <td-wb-input-group-field class="td-wb-assumptions__full-width">
                <input id="td-wb-lti-CPP-average-amount"
                       required
                       type="number"
                       name="CPPAverageAmount"
                       [min]="0"
                       [max]="999999"
                       tdWbInput
                       tdWbNumberInput="c0"
                       tdWbNumberInputGroupSeparator="true"
                       [disabled]="disableCPPQPPAmount"
                       [(ngModel)]="averageCPPQPPAmount"/>
                <td-wb-input-errors errorKeyNamespace="tdWb.lti.assumptions.errors.CPPQPPAMOUNT"
                                    [errorKeyDisplayBeforeSubmit]="['min', 'max','required']" />
              </td-wb-input-group-field>
            </td-wb-input-group>
          </div>
        </div>
      </div>
    </td-wb-form-row>
    <td-wb-divider class="td-wb-assumptions__divider" />
    <td-wb-form-row class="td-wb-assumptions__form-row"
                    role="region"
                    aria-labelledby="td-wb-aria-oas-header">
      <div> <!--the following is for Old Age Security-->
        <td-wb-inline-icon-wrapper class="td-wb-assumptions__form-row-title">
            <span id="td-wb-aria-oas-header"
                  role="heading"
                  aria-level="4"
                  translate="tdWb.lti.assumptions.OLD_AGE_SECURITY"></span>
          <td-wb-lti-assumptions-tooltip sectionId="OLD_AGE_SECURITY"
                                         position="center-right" />
        </td-wb-inline-icon-wrapper>
        <div class="td-wb-assumptions__spaced-row">
          <div class="td-wb-assumptions__spaced-column">
              <span id="td-wb-aria-include-oas-label"
                    translate="tdWb.lti.assumptions.INCLUDE_OAS"></span>
            <td-wb-radio-group id="td-wb-lti-OAS"
                               aria-labelledby="td-wb-aria-include-oas-label"
                               [(ngModel)]="includeOAS"
                               (change)="onIncludeOASChange()">
              <td-wb-radio name="noIncludeOAS"
                           value="No">
                <span translate="tdWb.lti.assumptions.NO_OPTION"></span>
              </td-wb-radio>
              <td-wb-radio name="includeOAS"
                           value="Yes">
                <span translate="tdWb.lti.assumptions.YES_OPTION"></span>
              </td-wb-radio>
            </td-wb-radio-group>
          </div>
          <div class="td-wb-assumptions__spaced-column">
            <span translate="tdWb.lti.assumptions.AVERAGE_OAS_AMOUNT"></span>
            <td-wb-input-group class="td-wb-assumptions__full-width">
              <td-wb-input-group-field class="td-wb-assumptions__full-width">
                <input id="td-wb-lti-OAS-average-amount"
                       type="number"
                       name="OASAverageAmount"
                       required
                       [min]="0"
                       [max]="999999"
                       tdWbInput
                       tdWbNumberInput="c0"
                       tdWbNumberInputGroupSeparator="true"
                       [disabled]="disableOASAmount"
                       [(ngModel)]="averageOASAmount"/>
                <td-wb-input-errors errorKeyNamespace="tdWb.lti.assumptions.errors.OASAMOUNT"
                                    [errorKeyDisplayBeforeSubmit]="['min', 'max', 'required']" />
              </td-wb-input-group-field>
            </td-wb-input-group>
          </div>
        </div>
      </div>
    </td-wb-form-row>
    <td-wb-divider class="td-wb-assumptions__divider" />
    <td-wb-form-row class="td-wb-assumptions__form-row">
      <div> <!--the following is for Retirement Income-->
        <div class="td-wb-assumptions__form-row-title">
              <span id="td-wb-aria-retirement-income-label"
                    translate="tdWb.lti.assumptions.OTHER_INCOME"></span>
        </div>
        <div class="td-wb-assumptions__column">
          <td-wb-inline-icon-wrapper>
                <span id="td-wb-aria-other-income-source-label"
                      translate="tdWb.lti.assumptions.OTHER_INCOME_SOURCE"></span>
            <td-wb-lti-assumptions-tooltip sectionId="OTHER_INCOME"
                                           position="center-bottom" />
          </td-wb-inline-icon-wrapper>
          <div class="td-wb-assumptions__row">
            <td-wb-input-group class="td-wb-assumptions__full-width">
              <td-wb-input-group-field class="td-wb-assumptions__full-width">
                <input id="td-wb-lti-other-income-amount"
                       type="number"
                       name="otherIncomeAmount"
                       [placeholder]=" 0 | tdWbCurrency: { format: 'c0' }"
                       aria-labelledby="td-wb-aria-other-income-source-label"
                       tdWbInputAriaDescribedBy="td-wb-aria-per-year-label"
                       [min]="0"
                       [max]="999999999"
                       tdWbInput
                       tdWbNumberInput="c0"
                       tdWbNumberInputGroupSeparator="true"
                       [(ngModel)]="additionalRetirementIncome"/>
                <td-wb-input-errors errorKeyNamespace="tdWb.lti.assumptions.errors.INCOME"
                                    [errorKeyDisplayBeforeSubmit]="['min', 'max']" />
              </td-wb-input-group-field>
            </td-wb-input-group>
            <span class="td-wb-assumptions__field-label"
                  id="td-wb-aria-per-year-label"
                  translate="tdWb.lti.assumptions.PER_YEAR"></span>
          </div>
        </div>
      </div>
    </td-wb-form-row>
    <td-wb-divider class="td-wb-assumptions__divider" />
    <td-wb-form-row class="td-wb-assumptions__form-row"
                    role="region"
                    aria-labelledby="td-wb-aria-economical-statistics-header">
      <div> <!--the following is for Economical & Statistical-->
        <div class="td-wb-assumptions__form-row-title">
                <span id="td-wb-aria-economical-statistics-header"
                      translate="tdWb.lti.assumptions.ECONOMICAL_STATISTICAL"></span>
        </div>
        <div class="td-wb-assumptions__spaced-row">
          <div class="td-wb-assumptions__spaced-column">
            <td-wb-inline-icon-wrapper>
              <span id="td-wb-aria-inflation-label"
                    translate="tdWb.lti.assumptions.EXPECTED_INFLATION"></span>
              <td-wb-lti-assumptions-tooltip sectionId="EXPECTED_INFLATION"
                                             position="center-right" />
            </td-wb-inline-icon-wrapper>
            <div class="td-wb-assumptions__row">
              <td-wb-input-group class="td-wb-assumptions__full-width">
                <td-wb-input-group-field class="td-wb-assumptions__full-width">
                  <input id="td-wb-lti-inflation-rate"
                         required
                         type="number"
                         name="inflationRate"
                         aria-labelledby="td-wb-aria-inflation-label"
                         tdWbInputAriaDescribedBy="td-wb-aria-inflation-per-year-label"
                         [min]="-5"
                         [max]="15"
                         tdWbInput
                         tdWbNumberInputGroupSeparator="true"
                         [(ngModel)]="inflationPercentage"/>
                  <td-wb-input-errors errorKeyNamespace="tdWb.lti.assumptions.errors.INFLATION"
                                      [errorKeyDisplayBeforeSubmit]="['min', 'max', 'required']" />
                </td-wb-input-group-field>
              </td-wb-input-group>
              <span class="td-wb-assumptions__field-label"
                    id="td-wb-aria-inflation-per-year-label"
                    translate="tdWb.lti.assumptions.PERCENTAGE_PER_YEAR"></span>
            </div>
          </div>
          <div class="td-wb-assumptions__spaced-column">
            <td-wb-inline-icon-wrapper>
              <span id="td-wb-aria-life-expectancy-label"
                    translate="tdWb.lti.assumptions.LIFE_EXPECTED"></span>
              <td-wb-lti-assumptions-tooltip sectionId="LIFE_EXPECTANCY"
                                             position="center-left" />
            </td-wb-inline-icon-wrapper>
            <div class="td-wb-assumptions__row">
              <td-wb-input-group class="td-wb-assumptions__full-width">
                <td-wb-input-group-field class="td-wb-assumptions__full-width">
                  <input id="td-wb-lti-life-expected"
                         class="td-wb-input--extra-small"
                         required
                         type="number"
                         name="lifeExpected"
                         aria-labelledby="td-wb-aria-life-expectancy-label"
                         tdWbInputAriaDescribedBy="td-wb-aria-years-label"
                         [min]="getMinLifeExpected()"
                         [max]="199"
                         tdWbInput
                         [maxDecimals]="0"
                         tdWbNumberInputGroupSeparator="true"
                         [(ngModel)]="lifeExpectedAge"/>
                  <td-wb-input-errors errorKeyNamespace="tdWb.lti.assumptions.errors.LIFEEXPECTANCY"
                                      [errorKeyDisplayBeforeSubmit]="['min', 'max', 'required', 'decimals']" />
                </td-wb-input-group-field>
              </td-wb-input-group>
              <span class="td-wb-assumptions__field-label"
                    id="td-wb-aria-years-label"
                    translate="tdWb.lti.assumptions.YEARS"></span>
            </div>
          </div>
        </div>
      </div><!--end economical & statistical session-->
    </td-wb-form-row>
    <td-wb-divider class="td-wb-assumptions__divider" />
    <div class="td-wb-assumptions__buttons">
      <!--the following is for reset assumptions & save button-->
      <button tdWbButton
              tdWbButtonType="secondary"
              (click)="onAssumptionResetClick()">
        <span translate="tdWb.lti.assumptions.ASSUMPTIONS_RESET"></span>
      </button>
      <button type="submit"
              tdWbButton
              tdWbButtonType="primary">
        <span translate="tdWb.lti.assumptions.ASSUMPTION_SAVE"></span>
      </button>
    </div>
  </td-wb-form>
</ng-template>
